﻿import { environment } from "../environments/environment";

export const appConfig = {
  // apiUrl: 'http://192.168.1.138:45455/api/'
  // apiUrl: 'http://localhost:58896/api/'
  apiUrl: environment.apiUrl
};
